import { useTranslation } from 'react-i18next';
import './LongLangSwitcher.css';
import ru from '../common/ru.png';
import en from '../common/en.png';

function LongLangSwitcher() {
    const { i18n } = useTranslation();
    const resolvedLanguage = i18n.resolvedLanguage;
    const lang = resolvedLanguage === 'en' ? 'Русский' : 'English';
    const src = resolvedLanguage === 'en' ? ru : en;
  
    const switchLanguage = () => {
        if(resolvedLanguage === 'en') i18n.changeLanguage('ru');
        else i18n.changeLanguage('en');
    };

    return (
        <div
            className='LongLangSwitcher'
            onClick={() => switchLanguage()}
        >
            <span>{lang}</span>
            <img alt='lang' src={src}/>
        </div>
    );
}

export default LongLangSwitcher;
